export default "__VITE_ASSET__DwvOjjkK__"